<template>
  <div style="min-height: 100%; padding-bottom: 30px">
    <el-row :gutter="10">
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>今日完成阅读人数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.todayDoneNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>今日发布任务数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.todayPublishTaskNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>教师人数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.teacherNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>学生人数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.studentNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>班级数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.classNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>在读人数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.readingStudentNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>在读图书数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.readingBooKNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>测评次数</span>
          </div>
          <div class="spb">
            <div>
              <img src="" alt="" />
            </div>
            <div style="text-align: center">
              <div class="number">{{ indexInfo.paperNumber }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>在读图书TOP10 (单位：人)</span>
          </div>
          <div id="top10" style="width: 100%; height: 400px"></div>
        </el-card>
      </el-col>
      <el-col :span="24" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>在读年级人数统计 (单位：人)</span>
          </div>
          <div id="numberChart" style="width: 100%; height: 400px"></div>
        </el-card>
      </el-col>
      <el-col :span="24" class="card-col">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>在读图书类型统计 (单位：人)</span>
          </div>
          <div id="typeChart" style="width: 100%; height: 400px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as homeApi from '@/api/home'
export default {
  data() {
    return {
      schoolId: '',
      indexInfo: {},
      top10: [],
      gradeCount: [],
      classifyCount: [],
      typeList: [
        {
          name: '期中',
          id: 2
        },
        {
          name: '期末',
          id: 3
        }
      ]
    }
  },
  methods: {
    schoolDataOverview() {
      let that = this
      homeApi
        .getReadStatisticsBase({
          schoolId: this.schoolId
        })
        .then((res) => {
          that.indexInfo = res.data.data
        })
    },
    statisticsBookCount() {
      let that = this
      homeApi
        .statisticsBookCount({
          schoolId: this.schoolId
        })
        .then((res) => {
          that.top10 = res.data.data.dataList
          var chartDom = document.getElementById('top10')
          var myChart = this.$echarts.init(chartDom)
          var option
          var xAxis = []
          var yAxis = []
          this.top10.map((item) => {
            xAxis.push(item.bookName)
            yAxis.push(item.studentNumber)
          })
          option = {
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'value'
            },
            yAxis: {
              type: 'category',
              data: xAxis,
              inverse: true
            },
            grid: {
              top: 20,
              left: 100,
              right: 20,
              bottom: 20
            },
            series: [
              {
                data: yAxis,
                type: 'bar',
                barMaxWidth: 20
              }
            ]
          }
          option && myChart.setOption(option)
        })
    },
    statisticsClassifyCount() {
      let that = this
      homeApi
        .statisticsClassifyCount({
          schoolId: this.schoolId
        })
        .then((res) => {
          that.classifyCount = res.data.data
          var chartDom = document.getElementById('typeChart')
          var myChart = this.$echarts.init(chartDom)
          var option
          var xAxis = []
          var yAxis = []
          this.classifyCount.map((item) => {
            xAxis.push(item.classifyName)
            yAxis.push(item.studentNumber)
          })
          option = {
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: xAxis
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: 20,
              left: 100,
              right: 20,
              bottom: 20
            },
            series: [
              {
                data: yAxis,
                type: 'line',
                smooth: true,
                areaStyle: {}
              }
            ]
          }
          option && myChart.setOption(option)
        })
    },
    statisticsGradeCount() {
      let that = this
      homeApi
        .statisticsGradeCount({
          schoolId: this.schoolId
        })
        .then((res) => {
          that.gradeCount = res.data.data
          var chartDom = document.getElementById('numberChart')
          var myChart = this.$echarts.init(chartDom)
          var option
          var xAxis = []
          var yAxis = []
          this.gradeCount.map((item) => {
            xAxis.push(item.gradeName)
            yAxis.push(item.studentNumber)
          })
          option = {
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: xAxis
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: 20,
              left: 100,
              right: 20,
              bottom: 20
            },
            series: [
              {
                data: yAxis,
                type: 'line',
                smooth: true,
                areaStyle: {}
              }
            ]
          }
          option && myChart.setOption(option)
        })
    }
  },
  mounted() {
    let info = JSON.parse(localStorage.getItem('info'))
    this.schoolId = info.schoolId
    console.log('index页面' + info.schoolId)
    this.schoolDataOverview()
    this.statisticsBookCount()
    this.statisticsGradeCount()
    this.statisticsClassifyCount()
  }
}
</script>
<style scoped>
.flex {
  display: flex;
}
.spb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.number {
  font-size: 36px;
}
.card-col {
  margin-bottom: 15px;
}
.xuhao {
  width: 25px;
  height: 25px;
  border: 1px solid #999;
  border-radius: 50%;
  color: #999;
  text-align: center;
  line-height: 25px;
  margin-right: 10px;
}
.isCurrent {
  color: #fff;
  border-color: #409eff;
  background: #409eff;
}
.timeInfo {
  flex: 1;
}
.infoTitle span {
  color: #999;
  font-size: 16px;
}
.titleCurrent span {
  color: #555;
}
.infoLine {
  height: 14px;
  flex: 1;
  margin-left: 10px;
  border-bottom: 1px solid #e6e6e6;
}
.infoRemark {
  margin-top: 10px;
  font-weight: 600;
}
.infoTime {
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue